import { Checkbox, Grid, IconButton, Stack, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import CancelIcon from "@mui/icons-material/Cancel";
import DialogBoxComp from "../../../components/common/DialogBox/DialogBoxComp";
import ScreenCard from "../../../components/common/ScreenCard/ScreenCard";
import TableComp from "../../../components/common/TableComp/TableComp";
import InputWithBtnLayoutComp from "../../../components/InputWithBtnLayout/InputWithBtnLayoutComp";
import InputComp from "../../../components/common/InputComp/Input";
import TabComp from "../../../components/TabsComp/TabComp";
import Btn from "../../../components/common/ButtonComp/Btn";
import { asyncStatus } from "../../../utils/asyncStatus";
import { primaryColor } from "../../../utils/themeColors";
import {
  addOMShipStatusAsync,
  deleteOMShipStatusAsync,
  editOMShipStatusAsync,
  getOMShipStatusAsync,
} from "../../../store/services/orderManagementService";
const ShipStatus = () => {
  const dispatch = useDispatch();
  const {
    getOMShipStatusStatus,
    getOMShipStatusError,
    getOMShipStatusData,
    addOMShipStatusStatus,
    addOMShipStatusData,
    addOMShipStatusError,

    editOMShipStatusStatus,
    editOMShipStatusError,
    editOMShipStatusData,

    deleteOMShipStatusData,
    deleteOMShipStatusStatus,
    deleteOMShipStatusError,
  } = useSelector((state) => state.om);

  useEffect(() => {
    dispatch(getOMShipStatusAsync());
  }, []);

  // console.log("getProductStyleData", getProductStyleData);
  const formattedData = getOMShipStatusData?.length
    ? getOMShipStatusData.map((style, index) => ({
        id: index + 1, // Assuming the index is a unique identifier for each row
        ...style,
      }))
    : [];
  const [selectedShipStatus, setSelectedShipStatus] = useState();
  const [addShipStatusMode, setAddShipStatusMode] = useState(false);
  const [addShipStatusData, setAddShipStatusData] = useState();
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [editData, setEditData] = useState();
  const [editMode, setEditMode] = useState(false);
  // console.log("selectedShipStatus", selectedShipStatus);
  // console.log("editData", editData);
  useEffect(() => {
    if (addOMShipStatusStatus === asyncStatus.SUCCEEDED) {
      setAddShipStatusMode(false);
      setSaveDisabled(true);
      setAddShipStatusData();
    }
  }, [, addOMShipStatusStatus]);

  const [open, setOpen] = useState(false);
  const agree = () => {
    dispatch(deleteOMShipStatusAsync(selectedShipStatus?.ship_status_id));
  };
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (deleteOMShipStatusStatus === asyncStatus.SUCCEEDED || deleteOMShipStatusStatus === asyncStatus.ERROR ) {
      setOpen(false);
      setSelectedShipStatus();
    }
  }, [, deleteOMShipStatusStatus]);
  useEffect(() => {
    if (editOMShipStatusStatus === asyncStatus.SUCCEEDED) {
      setSelectedShipStatus();
      setEditMode(false);
      setEditData()
    }
  }, [, editOMShipStatusStatus]);

  //   const [tableHeight, setTableHeight] = useState("");
  //   let elem = document.getElementById("containerHeight");
  //   useEffect(() => {
  //     console.log("elem?.offsetHeight",elem?.clientHeight);
  //     setTableHeight(elem?.offsetHeight);
  //   }, [ elem?.offsetHeight]);
  // console.log(containerHeight)
  return (
    <Stack padding={2}>
      <DialogBoxComp
        open={open}
        handleClose={handleClose}
        agree={agree}
        innerContent={"Are you sure you want to delete this ship status?"}
        heading={"Delete request"}
      />
      <ScreenCard
        title="Ship Status"
        customHeader={
          <Stack
            sx={{
              padding: 0.5,
              px: 4,
              backgroundColor: primaryColor,
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography sx={{ color: "white", fontWeight: "bold" }}>
              Ship Status
            </Typography>
            <Stack flexDirection={"row"} gap={1}>
              <IconButton
                onClick={() => {
                  setEditMode(false);
                  setAddShipStatusMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!addShipStatusMode ? (
                  <AddIcon sx={{ color: "white" }} />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addShipStatusMode}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  setAddShipStatusMode(false);
                  setEditMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!editMode ? (
                  <EditIcon />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addShipStatusMode || !selectedShipStatus}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => setOpen(true)}
              >
                <DeleteIcon />
              </IconButton>
              <IconButton
                disabled={
                  addOMShipStatusStatus === asyncStatus.LOADING ||
                  editOMShipStatusStatus === asyncStatus.LOADING ||
                  saveDisabled
                }
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  if (addShipStatusData) {
                    dispatch(addOMShipStatusAsync(addShipStatusData));
                  } else if (editMode) {
                    let a;
                    a = { ...selectedShipStatus, ...editData };
                    delete a.id;
                    dispatch(editOMShipStatusAsync(a));
                  }
                }}
              >
                <SaveIcon />
              </IconButton>
            </Stack>
          </Stack>
        }
      >
        <Grid container>
          <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
            <Stack height={500} width={"100%"}>
              <TableComp
                columns={[
                  { field: "ship_status_id", headerName: "ID", flex: true },
                  { field: "ship_status_name", headerName: "Ship Status", flex: true },
                ]}
                onRowClick={(e) => {
                  setSelectedShipStatus(e?.row);
                }}
                rows={formattedData}
                loading={
                  getOMShipStatusStatus === asyncStatus.IDLE ||
                  getOMShipStatusStatus === asyncStatus.LOADING
                }
              />
            </Stack>
          </Grid>
          <Grid item xl={9} lg={9} md={9} sm={12} xs={12} padding={2}>
            {addShipStatusMode ? (
              <InputWithBtnLayoutComp
              error={addOMShipStatusError}
                inputArray={[
                  {
                    label: "Ship Status:",
                    comp: (
                      <InputComp
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        onChange={(e) =>
                          setAddShipStatusData({
                            ...addShipStatusData,
                            ship_status_name: e.target.value,
                          })
                        }
                      />
                    ),
                  },
                  {
                    label: "Active:",
                    comp: (
                      <Checkbox
                        defaultChecked
                        defaultValue={true}
                        onChange={(e) =>
                          setAddShipStatusData({
                            ...addShipStatusData,
                            is_active: e.target.checked,
                          })
                        }
                      />
                    ),
                  },
                ]}
                secondaryComp={<></>}
              />
            ) : selectedShipStatus ? (
              <InputWithBtnLayoutComp
              error={editOMShipStatusError}
                inputArray={[
                  {
                    label: "ID:",
                    comp: (
                      <Typography sx={{ fontSize: 14 }}>
                        {selectedShipStatus?.ship_status_id}
                      </Typography>
                    ),
                  },
                  {
                    label: "ShipStatus:",
                    comp: (
                      <InputComp
                        key={selectedShipStatus?.ship_status_id} // Add key prop to force remount
                        disabled={!editMode}
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            ship_status_name: e.target.value,
                          })
                        }
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        defaultValue={selectedShipStatus?.ship_status_name}
                      />
                    ),
                  },
                  {
                    label: "Active:",

                    comp: (
                      <Checkbox
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            is_active: e.target.checked,
                          })
                        }
                        value={selectedShipStatus?.is_active|| editData?.is_active}
                        disabled={!editMode}
                        // defaultValue={selectedShipStatus?.is_active || editData?.is_active}
                        defaultChecked={selectedShipStatus?.is_active || editData?.is_active}
                        // checked={selectedShipStatus?.is_active}
                      />
                    ),
                  },
                ]}
                secondaryComp={
                  <Btn
                    style={{ fontSize: 10, fontWeight: "bold" }}
                    disabled={editMode}
                  >
                    Assign Companies
                  </Btn>
                }
              />
            ) : (<Stack>
              <Typography>Select any ship status</Typography>
              <Typography color={"red"} fontSize={12}>{getOMShipStatusError}</Typography>
            </Stack>
            )}
            <Stack my={2}>
              <TabComp
                tabs={[
                  //   {
                  //     name: "Companies",
                  //     content: (
                  //       <Stack height={400} width={"100%"}>
                  //         <TableComp
                  //           columns={[
                  //             {
                  //               field: "companyId",
                  //               headerName: "Company ID",
                  //               flex: true,
                  //             },
                  //             {
                  //               field: "companyName",
                  //               headerName: "Company Name",
                  //               flex: true,
                  //             },
                  //             {
                  //               field: "action",
                  //               headerName: "Action",
                  //               flex: true,
                  //             },
                  //           ]}
                  //           //   onRowClick={(e) => {
                  //           //     setSelectedShipStatus(e?.row);
                  //           //   }}
                  //           rows={[]}
                  //           //   loading={
                  //           //     getProductStyleStatus === asyncStatus.IDLE ||
                  //           //     getProductStyleStatus === asyncStatus.LOADING
                  //           //   }
                  //         />
                  //       </Stack>
                  //     ),
                  //   },
                  {
                    name: "Log Info",
                    content: (
                      <Stack height={400} width={"100%"}>
                        <TableComp
                          columns={[
                            {
                              field: "logId",
                              headerName: "Log ID",
                              flex: true,
                            },
                            {
                              field: "recordId",
                              headerName: "Record_id",
                              flex: true,
                            },
                            {
                              field: "columnName",
                              headerName: "Column Name",
                              flex: true,
                            },
                            {
                              field: "columnValue",
                              headerName: "Column Value",
                              flex: true,
                            },
                            {
                              field: "actionName",
                              headerName: "Action Name",
                              flex: true,
                            },
                            {
                              field: "actionDate",
                              headerName: "Action Date",
                              flex: true,
                            },
                            {
                              field: "userId",
                              headerName: " User ID",
                              flex: true,
                            },
                          ]}
                          //   onRowClick={(e) => {
                          //     setSelectedShipStatus(e?.row);
                          //   }}
                          rows={[]}
                          //   loading={
                          //     getProductStyleStatus === asyncStatus.IDLE ||
                          //     getProductStyleStatus === asyncStatus.LOADING
                          //   }
                        />
                      </Stack>
                    ),
                  },
                ]}
              />
            </Stack>
          </Grid>
        </Grid>

        {/* <div style={{ height: 400, width: '100%' }}>
      <DataGrid
      sty
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 5 },
          },
        }}
        pageSizeOptions={[5, 10]}
        // checkboxSelection
      />
    </div> */}
      </ScreenCard>
    </Stack>
  );
};

export default ShipStatus;
